// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.modal-title {
  color: #495057;
  font-weight: 600;
}

.modal-body {
  background-color: #ffffff;
}

.spinner-border {
  border-width: 0.3em;
}

.progress {
  background-color: #e9ecef;
  border-radius: 0.375rem;
  overflow: hidden;
}

.progress-bar {
  background-color: #007bff;
  transition: width 0.3s ease;
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: progress-bar-stripes 1s linear infinite;
}

@keyframes progress-bar-stripes {
  0% { background-position: 1rem 0; }
  100% { background-position: 0 0; }
}

.modal-footer {
  background-color: #f8f9fa;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/progress-modal/progress-modal.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,qMAAqM;EACrM,0BAA0B;AAC5B;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,wBAAwB,EAAE;AACnC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".modal-header {\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.modal-title {\n  color: #495057;\n  font-weight: 600;\n}\n\n.modal-body {\n  background-color: #ffffff;\n}\n\n.spinner-border {\n  border-width: 0.3em;\n}\n\n.progress {\n  background-color: #e9ecef;\n  border-radius: 0.375rem;\n  overflow: hidden;\n}\n\n.progress-bar {\n  background-color: #007bff;\n  transition: width 0.3s ease;\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 1rem 1rem;\n}\n\n.progress-bar-animated {\n  animation: progress-bar-stripes 1s linear infinite;\n}\n\n@keyframes progress-bar-stripes {\n  0% { background-position: 1rem 0; }\n  100% { background-position: 0 0; }\n}\n\n.modal-footer {\n  background-color: #f8f9fa;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
